import React from 'react';
import WebsiteLayout from './WebsiteLayout';
import GlobalPresence from './components/globalpresence';
import ContactUs from './components/contactus';



const RoboticsContact = () => {


    return(<>
    <WebsiteLayout>
     <ContactUs/>
     <GlobalPresence/>
    </WebsiteLayout>
    </>);


}

export default RoboticsContact;